/**
 * Normalize a user-entered URL for use as an external `<a href>`.
 *
 * Why: when a provider types "yoursite.com" (no protocol) into a website
 * field, the browser treats `<a href="yoursite.com">` as a RELATIVE path
 * and sends users to `gradlink.co/yoursite.com` instead of the intended
 * site. Same issue for LinkedIn, Instagram, Google Business URLs etc.
 * Stored values vary — some have https://, some have www. only, some are
 * bare domain — so we normalize at the render layer.
 *
 * Rules:
 *  - Empty/null → return as-is (caller should check before rendering an <a>)
 *  - mailto:, tel:, sms: → return as-is (not http URLs)
 *  - Starts with http:// or https:// → return as-is
 *  - Anything else (including //example.com, www.foo.com, foo.com/path) →
 *    prepend https://
 */
export function extUrl(value) {
  if (!value || typeof value !== 'string') return value;
  const trimmed = value.trim();
  if (!trimmed) return trimmed;
  // Non-http schemes pass through
  if (/^(mailto|tel|sms):/i.test(trimmed)) return trimmed;
  // Already absolute
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  // Protocol-relative
  if (trimmed.startsWith('//')) return 'https:' + trimmed;
  return 'https://' + trimmed;
}
